import React, { Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { urls } from '../router/urls';
import './Header.css';

const HeaderAux = () => {
  const { t, i18n } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const openMenuLang = () => {
    var element = document.getElementsByClassName('menu-idioma-pwa');
    element[0].classList.toggle('menu-idioma-pwa-open');
  };

  const changeLanguage = lang => {
    i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);
    openMenuLang()
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('lang'));
  }, [i18n]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <header className="site-header" role="banner">
			<nav className="global-nav" aria-label={t('header_govco_nav_aria')}>
				<div className="width-wrapper">
					<h1 id="govco-title">{t('header_govco_title')}</h1>
          {isMobile ? (
            <ul className='mobile-header'>
              <li>

            <form className="search-form search-mobile" action="" role="search">
              <div className="search-input">
                <label htmlFor="search-input" className="sr-only">{t('buscador_aria')}</label>
                <input type="search" id="search-input" name="query" placeholder={t('buscador')} aria-label={t('buscador_aria')} />
                <button type="submit" aria-label={t('buscar_aria')}>{t('buscar')}</button>
              </div>
            </form>
              </li>
                        <li>
                        <button
                          title={t('header_language')}
                          className="menu-idioma-btn"
                          aria-expanded="false"
                          aria-controls="language-menu"
                          onClick={openMenuLang}
                        >
                          <span className="menu-idioma-text">
                          {(localStorage.getItem('lang') || 'es').toUpperCase()}
                          </span>
                          <b className="collapse-sign">
                            <em className="fal fa-angle-down"> </em>
                          </b>
                        </button>
                        <ul className="menu-idioma-pwa" id="language-menu" role="menu">
                          <li className="">
                            <button
                              onClick={() => changeLanguage('es')}
                              title={t('header_spanish')}
                              className="menu-idioma-option"
                              role="menuitem"
                              aria-label={t('header_spanish_aria')}
                            >
                              <span>{t('espanol')}</span>
                            </button>
                          </li>
                          <li className="">
                          <button
                            onClick={() => changeLanguage('en')}
                            title={t('header_english')}
                            className="menu-idioma-option"
                            role="menuitem"
                            aria-label={t('header_english_aria')}
                          >
                            <span>{t('ingles')}</span>
                          </button>
                        </li>
          
                        <li className="">
                          <button
                            onClick={() => changeLanguage('pt')}
                            title={t('header_portuguese')}
                            className="menu-idioma-option"
                            role="menuitem"
                            aria-label={t('header_portuguese_aria')}
                          >
                            <span>{t('portugues')}</span>
                          </button>
                        </li>
                        </ul>
              </li>
              </ul>
          ) : (
					<ul className="nav-list top-level" aria-labelledby="govco-title">
						<li className="nav-item call-to-action secondary">
							<Link to={'/'+urls.login} role="link" aria-label={t('header_login_aria')}>{t('header_login')}</Link>
						</li>
            <li>
              <button
                title={t('header_language')}
                className="menu-idioma-btn"
                aria-expanded="false"
                aria-controls="language-menu"
                onClick={openMenuLang}
              >
                <span className="menu-idioma-text">
                {(localStorage.getItem('lang') || 'es').toUpperCase()}
                </span>
                <b className="collapse-sign">
                  <em className="fal fa-angle-down"> </em>
                </b>
              </button>
              <ul className="menu-idioma-pwa" id="language-menu" role="menu">
                <li className="">
                  <button
                    onClick={() => changeLanguage('es')}
                    title={t('header_spanish')}
                    className="menu-idioma-option"
                    role="menuitem"
                    aria-label={t('header_spanish_aria')}
                  >
                    <span>{t('espanol')}</span>
                  </button>
                </li>
                <li className="">
                <button
                  onClick={() => changeLanguage('en')}
                  title={t('header_english')}
                  className="menu-idioma-option"
                  role="menuitem"
                  aria-label={t('header_english_aria')}
                >
                  <span>{t('ingles')}</span>
                </button>
              </li>

              <li className="">
                <button
                  onClick={() => changeLanguage('pt')}
                  title={t('header_portuguese')}
                  className="menu-idioma-option"
                  role="menuitem"
                  aria-label={t('header_portuguese_aria')}
                >
                  <span>{t('portugues')}</span>
                </button>
              </li>
              </ul>
            </li>
					</ul>
          )}
				</div>
			</nav>
			<div>
				<nav role="navigation" aria-label={t('header_main_nav_aria')}>

					<nav className="main-nav" aria-label={t('header_main_menu_aria')}>
						<div className="width-wrapper">
                <Link to="/" aria-label={t('header_home_link_aria')}>

                </Link>
              {isMobile && (
                <button className="hamburger-menu-btn" onClick={toggleMenu} aria-expanded={isMenuOpen} aria-controls="mobile-menu" aria-label="Toggle mobile menu">
                  <i className="fas fa-bars"></i>
                </button>
              )}
              {isMobile ? (
                isMenuOpen && (
                  <div className="mobile-menu-container" id="mobile-menu">
                    <ul className="nav-list top-level" aria-labelledby="govco-title">
                        <li className="nav-item regular ">
											    <Link to="/colecciones" role="link" aria-label={t('header_collections_aria')}>{t('header_colecciones')}</Link>
                      </li>
                      {/* is_authenticated*/}
                        <li className="nav-item call-to-action primary">
											<Link to="#" role="link" aria-label={t('header_favorites_aria')}>
												<i className="far fa-heart fs-lg mr-1"></i>
												{t('header_favorites')}
											</Link>
                      {/* end is_authenticated*/}
                      
                      </li>
                      <li className="nav-item call-to-action secondary">
											<Link to={'/'+urls.login} role="link" aria-label={t('header_login_aria')}>{t('header_login')}</Link>
										</li>
                    </ul>
                  </div>
                )
              ) : (
							<ul className="nav-list top-level">
                <form className="search-form" action="" role="search">
						      <div className="search-input">
							      <label htmlFor="search-input" className="sr-only">{t('buscador_aria')}</label>
							      <input type="search" id="search-input" name="query" placeholder={t('buscador')} aria-label={t('buscador_aria')} />
							      <button type="submit" aria-label={t('buscar_aria')}>{t('buscar')}</button>
							    </div>
							  </form>
								<li className="nav-item regular ">
                      <Link to="/colecciones" role="link" aria-label={t('header_collections_aria')}>{t('header_colecciones')}</Link>
                      <img src="/static/images/rework/collection.gif" alt="Animación" class="gif-collections"></img>
								</li>
								<li className="nav-item call-to-action primary">
                  <Link to="#" role="link" aria-label={t('header_favorites_aria')}>
                    <i className="far fa-heart fs-lg mr-1"></i>
                    {t('header_favorites')}
                  </Link>
								</li>
							</ul>
              )}
						</div>
					</nav>
				</nav>
			</div>
		</header>
  );
};

const Loader = () => {
  const { t } = useTranslation();
  return (  
    <div className="App" role="status" aria-live="polite">
      <div>{t('header_loading')}</div>
    </div>
  )
};

export default function Header() {
  return (
    <Suspense fallback={<Loader />}>
      <HeaderAux />
    </Suspense>
  );
}
